let env = 'local_dev';
let local_http = 'http://localhost:8081';
let local_dev_http = 'http://localhost:8081';
let remote_http = "http://192.168.153.204:8082";
let http_url = local_http;
if (env === 'local_dev') {
    http_url = local_dev_http;
}else if (env === 'remote'){
    http_url = remote_http
}

export default {
    http_url
}